import React, { FC } from 'react';
import { RootState } from '../store';
import { useSelector } from 'react-redux';
import { DeviceType, Platform, AppView, Orientation } from 'sofa-reborn-react';
import DeleteOverlay from '../components/DeleteOverlay';

const DeleteOverlayContainer: FC = () => {
	const deviceType = useSelector<RootState, DeviceType>((state) => state.deviceInfo.deviceType);
	const platform = useSelector<RootState, Platform>((state) => state.deviceInfo.platform);
	const orientation = useSelector<RootState, Orientation>((state) => state.deviceInfo.orientation);
	const appView = useSelector<RootState, AppView>((state) => state.application.appView);
	const pointerOverDragArea = useSelector<RootState, boolean>(
		(state) => state.scene.pointerOverDropArea
	);

	return (
		<DeleteOverlay
			deviceType={deviceType}
			platform={platform}
			orientation={orientation}
			appView={appView}
			pointerOverDragArea={pointerOverDragArea}
		></DeleteOverlay>
	);
};

export default DeleteOverlayContainer;
